import { App } from "@capacitor/app";
import { Browser } from "@capacitor/browser";

import { track } from "shared/boot/analytics";
import { MENTION_TYPE_SHORT_TO_LONG } from "shared/types/mentions/index";

let isLoggedIn = false;
export default {
  async closeInAppBrowser() {
    try {
      await Browser.close();
    } catch (error) {
      if (error?.message !== "No active window to close!") {
        throw error;
      }
    }
  },
  getMentionDetails(mentionId) {
    const mediaId = parseInt(
      mentionId.replace(/(RA|TS|TC|TL|ON|PR|MA|TW)/, ""),
      10
    );

    const mediaType =
      MENTION_TYPE_SHORT_TO_LONG[mentionId.substring(0, 2)] || "";

    const params = mentionId.substring(12);

    return { id: mediaId, params, type: mediaType };
  },
  getRedirectUrl(event) {
    // extract the mediaId from URL
    const matches = event.url.match(/(RA|TS|TC|TL|ON|PR|MA|TW)[0-9]*/g);

    if (!matches) return "/";

    const mentionDetails = this.getMentionDetails(matches[0]);

    switch (mentionDetails.type) {
      case "article":
      case "radio_clip":
      case "tv_caption":
      case "tv_logo_appearance":
      case "tv_super":
      case "tweet":
        return `/${mentionDetails.type}s/${mentionDetails.id}${mentionDetails.params}`;
      case "magazine_article":
      case "paper_article":
        return `/mention-alert/${mentionDetails.type}_mention/${mentionDetails.id}`;
      default:
        return "/";
    }
  },
  setIsLoggedIn(value) {
    isLoggedIn = value;
  },
  start(router) {
    App.addListener("appUrlOpen", async (event) => {
      if (event.url.match(/\/oauth|\/sign-in|\/skilljar/)) {
        if (event.url.match(/:\/\/oauth/)) {
          // handle for app schema urls, eg streem://oauth
          const fullPath = event.url.substring(event.url.indexOf("/oauth"));

          router.push(fullPath);
        } else {
          const url = new URL(event.url);
          const path = url.pathname;
          const queryParams = url.search;
          const fullPath = path + queryParams;

          router.push(fullPath);
        }

        await this.closeInAppBrowser();

        return;
      }

      if (!isLoggedIn) return;

      const redirectUrl = this.getRedirectUrl(event);

      if (redirectUrl !== router.currentRoute) {
        track("Universal Link Opened", {
          targetUrl: redirectUrl,
          type: "Direct Link",
          url: event.url,
        });

        router.push(redirectUrl);
      }
    });
  },
};
